module.exports = __webpack_public_path__ + "img/links.54d2b4fe.svg";